// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0f355d7b","453":"4010f262","455":"5244b823","977":"ea443ab3"}[chunkId] + ".chunk.js";
};